export const getInitials = (name = '', secondName = ''): string =>
  `${name} ${secondName}`
    .split(' ')
    .map(text => text.slice(0, 1))
    .join('')
    .slice(0, 2);

export const getFullName = (firstName = '', lastName = ''): string => `${firstName} ${lastName}`;
